module.exports = __webpack_public_path__ + "img/emoji_67.58f2a0ce.png";